import { openURL } from 'quasar'

export default ({ Vue }) => {
  Vue.prototype.$download = openURL
}
